
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  SET_CONFIGURATIONS: (state, payload) => state.configurations = payload,

}